// extracted by mini-css-extract-plugin
module.exports = {"container":"et","productName":"ft","modal":"gt","dimensions":"ht","recipientEmail":"it","lowStock":"jt","recommendedFit":"kt"};